import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { CurriculumOverview } from '../components/CurriculumOverview';
import { CourseGrid } from '../components/CourseGrid';
import { SpeakersSection } from '../components/SpeakersSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { CurriculumPopup } from '../components/CurriculumPopup';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780]" data-id="element-563">
      <Navbar data-id="element-564" />
      <main data-id="element-565">
        <HeroSection data-id="element-566" />
        <AboutSection data-id="element-567" />
        <CurriculumOverview data-id="element-568" />
        <CourseGrid data-id="element-569" />
        <SpeakersSection data-id="element-570" />
        <TestimonialsSection data-id="element-571" />
        <CTASection data-id="element-572" />
      </main>
      <Footer data-id="element-573" />
      <CookieBanner data-id="element-574" />
      <CurriculumPopup data-id="element-575" />
    </div>;
}